import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
//import './Communication.css';

class Communication extends Component {
    render(){
        return (
            <div>
                <h1>Ward Communication</h1>
                <p></p>
                <Table id="comms-table" striped bordered hover>
                    <tbody>
                        <CommunicationItem image="images/member-tools.png" name="Member Tools App" text="Ward and Stake Directory, Ward organization, Ministering assignments and more. Download in app store and sign in with church account." />
                        <CommunicationItem image="images/gospel-living.png" name="Gospel Living App" text="For classes, quorums, and general ward communication. Download in app store and sign in with church account." />
                        <CommunicationItem image={null} name="lfward.org" text="Weekly Sacrament Meeting program, Zoom links, announcements." />
                        {/*<CommunicationItem image="images/groupme.png" name="GroupMe App" >Relief Society communication. Click on the link to join. <a href="https://groupme.com/join_group/53133033/eFTFW2Sz">https://groupme.com/join_group/53133033/eFTFW2Sz</a></CommunicationItem>*/}
                        <CommunicationItem image="images/instagram.png" name="Instagram App" text="Relief Society Communication. Download app, create account, and add Lake_Forest_rs" />
                    </tbody>
                </Table>
            </div>
        );
    }
}

export class CommunicationItem extends Component {
    render(){
        const {image, name, text, children} = this.props;
        let body;
        if(children){
            body = children;
        } else if(text){
            body = text;
        } else {
            body = null;
        }
        return <>
            <tr>
                <td>{image && <img src={image} width="100px" height="100px"  alt="name"/>}</td>
                <td>{name}</td>
                <td>{body}</td>
            </tr>
        </>
    }
}

export default Communication;